// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" mono-occurrence-out="vm.monoOccurrence"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="trs" multi-occurrence-options="vm.trsMultiOccurrenceOptions"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;